/**
 * Adds hover actions to map on location-module.twig
 * Uses vertical-tag.js to add click actions
 * Make sure `const tabs = document.querySelectorAll('.vert-tab-nav a, .location-pin ');`
 * in vertical-tabs.js contain `.location-pin`
 * 
 * and points on map contain the following attribute and class
 * data-tabid="tab-Peoria" 
 * class="location-pin"
 * 
 * styles also need to have `cursor: pointer`
 * .st5{fill-rule:evenodd;clip-rule:evenodd;fill:#E3EF75;stroke:#8DC856;cursor: pointer;}
 * .st6{fill-rule:evenodd;clip-rule:evenodd;fill:#5BC6CC;stroke:#004F83;cursor: pointer;}
 * 
 */
export function mapSetup(){
    
    var tooltip = document.getElementById('tooltip');
    // console.log('map setup', locations);

    var module = document.getElementById('location-map');

    document.querySelectorAll('.st5, .st6').forEach(function(pin){
        pin.addEventListener("mouseenter", function( event ) {
            var location = locations[event.target.id];
            // console.log('mouseenter', event.target);
            tooltip.innerHTML = `${location.locationName}, ${location.locationState}`;
            tooltip.classList.remove('hidden');
        });
        pin.addEventListener("mouseout", function( event ) {
            // console.log('mouseover', event.target.id);
            tooltip.classList.add('hidden');
        });
        pin.addEventListener("click", function( event) {
            var location = locations[event.target.id];
            window.location = location.locationURL;
        })
    });

    module.addEventListener('mousemove', function(event){
        var offset = getOffset(module);
        // console.log('mousemove', event.clientX, event.clientY);
        tooltip.style.left = (event.pageX ) + 'px';
        tooltip.style.top = (event.pageY - 50 ) + 'px';
    });

    paymentLinksReady();
}

function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
}

const paymentLinksReady = () => {
    if (document.querySelector('#map-modal-wrapper')) {
        document.querySelector('#map-modal-wrapper').addEventListener('click', togglePayments);
        document.querySelector('#close-map-popup').addEventListener('click', togglePayments);
        document.querySelector('.map-modal').addEventListener('click', (e) => { e.stopPropagation()});
        document.querySelectorAll('.map-preview-link').forEach( function(link) {
            link.addEventListener('click', togglePayments );
        });
        document.addEventListener('keyup', function(e) {
            if (e.key === "Escape") { // escape key maps to keycode `27`
                document.querySelector('#map-modal-wrapper').classList.remove('opened');
            }
       });
    }
}

let modalClass = 'yellow-theme';
  
const togglePayments = (e) => {
    e.preventDefault();
    console.log('toggle map modal', e);
    const src = e.target.dataset.src;
    document.querySelector('#map-large-image').setAttribute('src', src);
    document.querySelector('#map-modal-wrapper .map-modal').classList.remove(modalClass);
    modalClass = e.target.dataset.class
    document.querySelector('#map-modal-wrapper .map-modal').classList.add(modalClass);
    document.querySelector('#map-modal-wrapper').classList.toggle('opened');
}



mapSetup();